import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../components/Buttons';
import { getPropByName } from '../../../utils/props';
import { Times } from '../../../components/Icon';
import { HBox } from '../../../components/Box';
import { Checkbox } from '../../../components/Checkbox';
import { USERS_CRUD } from '../../../components/Permission/constants';
import { Permission } from '../../../components/Permission';
import { updateUser } from '../actions';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import { Card } from '../../../components/Card';

const Container = styled.div`
  font-size: 14px;
  align-self: stretch;

  .cell:first-child {
    text-transform: capitalize;
  }

  & ~ .button-row {
    display: flex;
    justify-content: end;
  }
`;

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class UserDataCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  render() {
    const user = this.props.user;
    return (
      <Card className="user-info-card info-card info">
        <Container>
          <HBox vCenter>
            <div>
              <span style={{ opacity: '0.4' }}>({user.id})&nbsp;</span>
              <span style={{ fontWeight: '600' }}>
                {getPropByName(user, 'name')}&nbsp;{getPropByName(user, 'surname')}
              </span>
              <br />
              {getPropByName(user, 'email_address')}
            </div>

            {this.props.onRemove ? (
              // eslint-disable-next-line no-restricted-globals, no-alert
              <div className="me-2">
                <ButtonComponent size="btn-sm" style="ButtonSoftDelete" onClick={this.props.onRemove}>
                  <Times />
                </ButtonComponent>
              </div>
            ) : null}
          </HBox>
          <Permission permission={USERS_CRUD}> 
            <HBox>
              
                <Checkbox checked={this.props.user?.weblogin ?? false} onChange={this.props.togglWebloginProp.bind(this)}>
                  <strong>{this.lbl('user.details.weblogin')}</strong>
                </Checkbox>
        
            </HBox>
            <HBox>
              <Checkbox
                checked={this.props.user?.can_login_to_vindat ?? false}
                onChange={this.props.togglCanLoginToVindatProp.bind(this)}
              >
                <strong>{this.lbl('user.details.can_login_to_vindat')}</strong>
              </Checkbox>
            </HBox>
            <HBox>
              <Checkbox checked={!!this.props.user?.azure_id} disabled={true}>
                <strong>{this.lbl('user.details.is_migrated_to_azure')}</strong>
              </Checkbox>
            </HBox>
          </Permission>
        </Container>
      </Card>
    );
  }
}

UserDataCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    togglWebloginProp() {
      const newValue = !ownProps.user?.['weblogin'];
      const dto = { weblogin: newValue };
      dispatch(updateUser(ownProps.user?.id, dto));
    },
    togglCanLoginToVindatProp() {
      const newValue = !ownProps.user?.['can_login_to_vindat'];
      const dto = { can_login_to_vindat: newValue };
      dispatch(updateUser(ownProps.user?.id, dto));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const UserDataCard = compose(withConnect, withRouter)(UserDataCardComp);
